export default "__VITE_ASSET__BJ7z32Hy__"